function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: SCRIPTHASH opcode — hash a resolved JSON script tree via canonical Script::hash.
 *
 * Language shape:
 *   script.source — JSON object (literal or resolve_ref path, e.g. context.rental_script)
 *   script.into   — short key under context.__opcodes.scripthash
 *
 * Does NOT reimplement hashing. When app.core.scripting.hash is available, uses that
 * (WASM → Script::hash). Otherwise fails closed so a second JS hash path cannot diverge.
 */

module.exports = {
  name: 'SCRIPTHASH',
  description: "\nResolves a JSON script tree and stores the canonical script hash under\ncontext.__opcodes.scripthash.<into>.\n\nThe hash is computed by the Rust Script::hash implementation (via app.core.scripting.hash).\nWitness stripping and canonicalization are not duplicated in JavaScript.\n",
  exampleScript: {
    op: 'SCRIPTHASH',
    source: 'context.rental_script',
    into: 'hash'
  },
  execute: function execute(node, context) {
    var _context$app;
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(node, 'source')) {
      return false;
    }
    var key = node.into;
    if (typeof key !== 'string' || !/^[a-zA-Z0-9_]+$/.test(key)) {
      return false;
    }
    var resolved = resolveRef(context, node.source);
    if (!resolved || _typeof(resolved) !== 'object' || Array.isArray(resolved)) {
      return false;
    }
    var hashFn = (_context$app = context.app) === null || _context$app === void 0 || (_context$app = _context$app.core) === null || _context$app === void 0 || (_context$app = _context$app.scripting) === null || _context$app === void 0 ? void 0 : _context$app.hash;
    if (typeof hashFn !== 'function') {
      return false;
    }
    var hash;
    try {
      hash = hashFn(resolved);
    } catch (err) {
      return false;
    }
    if (typeof hash !== 'string' || hash.length === 0) {
      return false;
    }
    if (!context.__opcodes) {
      context.__opcodes = {};
    }
    if (!context.__opcodes.scripthash) {
      context.__opcodes.scripthash = {};
    }
    context.__opcodes.scripthash[key] = hash;
    return true;
  }
};
function resolveRef(root, ref) {
  if (typeof ref !== 'string') {
    return ref;
  }
  var path = ref.startsWith('context.') ? ref.slice('context.'.length) : ref;
  var parts = path.split('.');
  var cursor = root;
  for (var i = 0; i < parts.length; i += 1) {
    var key = parts[i];
    if (!cursor || _typeof(cursor) !== 'object' || !Object.prototype.hasOwnProperty.call(cursor, key)) {
      return ref;
    }
    cursor = cursor[key];
  }
  return cursor;
}